import axios from "axios";
import { API_URL } from "../variables";
export const FETCH_FILTERED_PRODUCTS_REQUEST =
  "FETCH_FILTERED_PRODUCTS_REQUEST";
export const FETCH_FILTERED_PRODUCTS_SUCCESS =
  "FETCH_FILTERED_PRODUCTS_SUCCESS";
export const FETCH_FILTERED_PRODUCTS_FAILURE =
  "FETCH_FILTERED_PRODUCTS_FAILURE";

export const fetchFilteredProducts = (filters) => async (dispatch) => {
  dispatch({ type: FETCH_FILTERED_PRODUCTS_REQUEST });
  try {
    // Ensure category_id is always an array
    const filterPayload = {
      ...filters,
      category_id: Array.isArray(filters.category_id) ? filters.category_id : (filters.category_id ? [filters.category_id] : []),
    };

    const response = await axios.post(
      `${API_URL}/api/products/filter?page=${filterPayload.page || 1}`,
      filterPayload
    );
    
    // Handle paginated response structure from Django REST Framework
    // Response structure: { count, next, previous, results: [...] }
    const responseData = response.data;
    
    dispatch({
      type: FETCH_FILTERED_PRODUCTS_SUCCESS,
      payload: {
        products: {
          results: responseData.results || (Array.isArray(responseData) ? responseData : []),
          count: responseData.count || (Array.isArray(responseData) ? responseData.length : 0),
          next: responseData.next || null,
          previous: responseData.previous || null,
        },
      },
    });
  } catch (error) {
    dispatch({
      type: FETCH_FILTERED_PRODUCTS_FAILURE,
      error: error.message,
    });
  }
};

export const FETCH_ADVANCED_SEARCH_REQUEST = "FETCH_ADVANCED_SEARCH_REQUEST";
export const FETCH_ADVANCED_SEARCH_SUCCESS = "FETCH_ADVANCED_SEARCH_SUCCESS";
export const FETCH_ADVANCED_SEARCH_FAILURE = "FETCH_ADVANCED_SEARCH_FAILURE";

export const fetchAdvancedSearch = (searchData) => async (dispatch) => {
  dispatch({ type: FETCH_ADVANCED_SEARCH_REQUEST });
  try {
    const response = await axios.post(
      `${API_URL}/api/products/advanced-search`,
      searchData
    );
    dispatch({
      type: FETCH_ADVANCED_SEARCH_SUCCESS,
      payload: {
        results: response.data.results || [],
        suggestions: response.data.suggestions || [],
        totalResults: response.data.total_results || 0,
        searchTerm: response.data.search_term || "",
      },
    });
  } catch (error) {
    dispatch({
      type: FETCH_ADVANCED_SEARCH_FAILURE,
      error: error.message,
    });
  }
};
